"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badges = void 0;
var GameVars_1 = require("../../../GameVars");
var Badges = /** @class */ (function (_super) {
    __extends(Badges, _super);
    function Badges(scene) {
        var _this = _super.call(this, scene) || this;
        _this.y = 150 * GameVars_1.GameVars.scaleY;
        _this.x = -165;
        _this.scaleY = GameVars_1.GameVars.scaleY;
        for (var i = 0; i < GameVars_1.GameVars.modeGameData.restartCounter; i++) {
            var badget = new Phaser.GameObjects.Image(_this.scene, 26.5 * i, 0, "texture_atlas_1", "restart_badge_" + (i + 1));
            badget.setScale(.5);
            _this.add(badget);
        }
        return _this;
    }
    return Badges;
}(Phaser.GameObjects.Container));
exports.Badges = Badges;
